import { render, staticRenderFns } from "./rooms-select.vue?vue&type=template&id=44561b14&scoped=true&"
import script from "./rooms-select.js?vue&type=script&lang=js&"
export * from "./rooms-select.js?vue&type=script&lang=js&"
import style0 from "./rooms-select.css?vue&type=style&index=0&id=44561b14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44561b14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
